/* Scandinavian Muse — tema "Musa". JavaScript sem dependências. */
(() => {
  'use strict';
  const M = window.musa || { rotas: {}, textos: {}, entrega: {} };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const movimentoReduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const computador = () => window.matchMedia('(min-width: 1100px)').matches;

  /* ---------- dinheiro (formato da loja, ex.: "{{amount_with_comma_separator}} kr") ---------- */
  const dinheiro = centimos => {
    const f = M.formatoDinheiro || '{{amount_with_comma_separator}}';
    const n = Number(centimos || 0) / 100;
    const com = (casas, mil, dec) => {
      const [i, d] = n.toFixed(casas).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, mil) + (d ? dec + d : '');
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: com(2, ',', '.'), amount_no_decimals: com(0, ',', '.'),
      amount_with_comma_separator: com(2, '.', ','), amount_no_decimals_with_comma_separator: com(0, '.', ','),
      amount_with_apostrophe_separator: com(2, "'", '.'), amount_with_space_separator: com(2, ' ', ','),
      // à checa: "1 599 Kč" (inteiros, espaço nos milhares)
      amount_no_decimals_with_space_separator: com(0, ' ', ','), amount_with_period_and_space_separator: com(2, ' ', '.'),
    }[k] ?? com(2, '.', ',')));
  };

  /* ---------- aviso curto ---------- */
  let toastTempo;
  const toast = texto => {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = texto;
    t.classList.add('esta-visivel');
    clearTimeout(toastTempo);
    toastTempo = setTimeout(() => t.classList.remove('esta-visivel'), 2800);
  };

  /* ---------- cabeçalho: fundo ao rolar e quando se está a usar o menu ---------- */
  const cab = $('[data-cabecalho]');
  const aoRolar = () => cab && cab.classList.toggle('esta-rolado', window.scrollY > 8);
  aoRolar();
  window.addEventListener('scroll', aoRolar, { passive: true });
  if (cab) {
    cab.addEventListener('mouseenter', () => computador() && cab.classList.add('esta-ativo'));
    cab.addEventListener('mouseleave', () => { if (!$('[data-mega].esta-aberto', cab)) cab.classList.remove('esta-ativo'); });
    cab.addEventListener('focusin', () => cab.classList.add('esta-ativo'));
    cab.addEventListener('focusout', e => { if (!cab.contains(e.relatedTarget)) cab.classList.remove('esta-ativo'); });
  }

  // menu grande: abre ao passar o rato (com um pequeno atraso para não piscar) e com o teclado
  $$('[data-mega]').forEach(item => {
    const ligacao = $('.nav__ligacao', item);
    let entrar, sair;
    const abrir = () => {
      clearTimeout(sair);
      $$('[data-mega].esta-aberto').forEach(o => o !== item && fechar(o));
      item.classList.add('esta-aberto');
      ligacao.setAttribute('aria-expanded', 'true');
      cab && cab.classList.add('esta-ativo');
    };
    const fechar = el => {
      el.classList.remove('esta-aberto');
      $('.nav__ligacao', el).setAttribute('aria-expanded', 'false');
    };
    item.addEventListener('mouseenter', () => { clearTimeout(sair); entrar = setTimeout(abrir, 90); });
    item.addEventListener('mouseleave', () => { clearTimeout(entrar); sair = setTimeout(() => fechar(item), 180); });
    ligacao.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown' || ((e.key === 'Enter' || e.key === ' ') && !item.classList.contains('esta-aberto'))) {
        e.preventDefault(); abrir(); const p = $('.mega a', item); p && p.focus();
      }
    });
    item.addEventListener('focusout', e => { if (!item.contains(e.relatedTarget)) fechar(item); });
    item.addEventListener('keydown', e => { if (e.key === 'Escape') { fechar(item); ligacao.focus(); } });
  });

  /* ---------- gavetas (menu, saco, filtros, guia de tamanhos) ---------- */
  let gavetaAberta = null;
  let focoAntes = null;
  const abrirGaveta = id => {
    const g = document.getElementById(id);
    if (!g) return;
    if (gavetaAberta && gavetaAberta !== g) fecharGaveta(false);
    focoAntes = document.activeElement;
    g.classList.add('esta-aberta');
    g.setAttribute('aria-hidden', 'false');
    gavetaAberta = g;
    document.documentElement.style.overflow = 'hidden';
    $$(`[data-abrir="${id}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => { const f = $('[data-fechar]:not(.gaveta__fundo), button, a, input', $('.gaveta__painel', g)); f && f.focus({ preventScroll: true }); }, 80);
  };
  function fecharGaveta(devolverFoco = true) {
    if (!gavetaAberta) return;
    gavetaAberta.classList.remove('esta-aberta');
    gavetaAberta.setAttribute('aria-hidden', 'true');
    $$(`[data-abrir="${gavetaAberta.id}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
    gavetaAberta = null;
    document.documentElement.style.overflow = '';
    if (devolverFoco && focoAntes && focoAntes.focus) focoAntes.focus({ preventScroll: true });
  }
  document.addEventListener('click', e => {
    const abrir = e.target.closest('[data-abrir]');
    if (abrir) { e.preventDefault(); abrirGaveta(abrir.dataset.abrir); return; }
    if (e.target.closest('[data-fechar]')) { e.preventDefault(); fecharGaveta(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { fecharGaveta(); fecharPesquisa(); } });

  /* ---------- separadores (menu do telemóvel e grelhas de produtos) ---------- */
  const ligarSeparadores = (grupo, seletorBotao) => {
    const botoes = $$(seletorBotao, grupo);
    const escolher = b => {
      botoes.forEach(x => {
        const ativo = x === b;
        x.setAttribute('aria-selected', String(ativo));
        x.tabIndex = ativo ? 0 : -1;
        const painel = document.getElementById(x.getAttribute('aria-controls'));
        if (painel) painel.hidden = !ativo;
      });
    };
    botoes.forEach((b, i) => {
      b.tabIndex = b.getAttribute('aria-selected') === 'true' ? 0 : -1;
      b.addEventListener('click', () => escolher(b));
      b.addEventListener('keydown', e => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        const n = botoes[(i + d + botoes.length) % botoes.length];
        n.focus(); escolher(n);
      });
    });
  };
  $$('.menu-movel').forEach(m => ligarSeparadores(m, '[data-separador]'));
  $$('[data-separadores]').forEach(s => ligarSeparadores(s, '[data-separador]'));

  /* ---------- abertura (fotografias que passam) ---------- */
  $$('[data-heroi]').forEach(h => {
    const slides = $$('[data-heroi-slide]', h);
    const pontos = $$('[data-heroi-ir]', h);
    const pausa = $('[data-heroi-pausa]', h);
    const intervalo = Number(h.dataset.intervalo) || 7000;
    h.style.setProperty('--intervalo', `${intervalo}ms`);
    let atual = 0;
    let relogio = null;
    let pausado = movimentoReduzido;
    // fotografia clara (texto escuro): os indicadores e o cabeçalho por cima passam também a escuro
    const tom = () => {
      const claro = slides[atual] && slides[atual].classList.contains('heroi__slide--escuro');
      h.classList.toggle('heroi--claro', claro);
      if (h.closest('.secao-heroi') && h.closest('main')?.firstElementChild === h.closest('.secao-heroi')) document.body.classList.toggle('sobre-claro', claro);
    };
    const ir = i => {
      atual = (i + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('esta-ativo', k === atual); s.setAttribute('aria-hidden', String(k !== atual)); });
      tom();
      pontos.forEach((p, k) => {
        p.classList.toggle('esta-ativo', k === atual);
        p.classList.toggle('foi-visto', k < atual);
        k === atual ? p.setAttribute('aria-current', 'true') : p.removeAttribute('aria-current');
        const barra = $('i', p);
        if (barra) { barra.style.animation = 'none'; void barra.offsetWidth; barra.style.animation = ''; }
      });
      programar();
    };
    const programar = () => { clearTimeout(relogio); if (!pausado && slides.length > 1) relogio = setTimeout(() => ir(atual + 1), intervalo); };
    const definirPausa = p => {
      pausado = p;
      h.classList.toggle('esta-pausado', p);
      if (pausa) pausa.setAttribute('aria-label', p ? pausa.dataset.textoContinuar : pausa.dataset.textoPausar);
      p ? clearTimeout(relogio) : programar();
    };
    pontos.forEach(p => p.addEventListener('click', () => ir(Number(p.dataset.heroiIr))));
    pausa && pausa.addEventListener('click', () => definirPausa(!pausado));
    // deslizar com o dedo
    let x0 = null;
    h.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    h.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) ir(atual + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    document.addEventListener('visibilitychange', () => { if (document.hidden) clearTimeout(relogio); else programar(); });
    tom();
    definirPausa(pausado);
  });

  /* ---------- bolhas: as fotografias de cada coleção vão passando, desencontradas ---------- */
  $$('[data-bolhas]').forEach(lista => {
    const bolhas = $$('[data-bolha]', lista).filter(b => b.children.length > 1);
    if (!bolhas.length || movimentoReduzido) return;
    const intervalo = Number(lista.dataset.intervalo) || 3000;
    let visivel = true;
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { visivel = e.isIntersecting; }).observe(lista);
    bolhas.forEach((b, k) => {
      const fotos = [...b.children];
      let i = 0;
      setTimeout(() => setInterval(() => {
        if (!visivel || document.hidden) return;
        fotos[i].classList.remove('esta-ativa');
        i = (i + 1) % fotos.length;
        fotos[i].classList.add('esta-ativa');
      }, intervalo), Math.round((k * intervalo) / bolhas.length));
    });
  });

  /* ---------- cartões: a amostra de cor mostra a fotografia dessa cor na foto grande ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-cor]');
    if (!b) return;
    e.preventDefault();
    const cartao = b.closest('[data-cartao-produto]');
    const img = cartao && $('.cartao-produto__imagem:not(.cartao-produto__imagem--2)', cartao);
    if (!img) return;
    if (b.dataset.corSrcset) img.srcset = b.dataset.corSrcset;
    img.src = b.dataset.corSrc;
    $$('[data-cor]', cartao).forEach(x => { x.classList.toggle('esta-ativa', x === b); x.setAttribute('aria-pressed', String(x === b)); });
    // a segunda foto (ao passar o rato) já não é desta cor
    $('.cartao-produto__palco', cartao)?.classList.remove('cartao-produto__palco--duas');
    if (b.dataset.corUrl) $$('.cartao-produto__palco, .cartao-produto__nome a', cartao).forEach(a => { a.href = b.dataset.corUrl; });
  });

  /* ---------- barra de anúncios ---------- */
  $$('[data-anuncio]').forEach(a => {
    const itens = () => $$('.anuncio__item:not([hidden])', a);
    if (itens().length < 2 || movimentoReduzido) return;
    let i = 0;
    setInterval(() => {
      const lista = itens();
      if (lista.length < 2) return;
      lista.forEach(x => x.classList.remove('esta-ativo'));
      i = (i + 1) % lista.length;
      lista[i].classList.add('esta-ativo');
    }, 4500);
  });

  /* ---------- contagens decrescentes (data do fim da promoção, hora de Praga) ---------- */
  const fimEmPraga = texto => {
    const m = String(texto || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    const [, a, me, d, h = '23', mi = '59'] = m;
    const utc = Date.UTC(+a, +me - 1, +d, +h, +mi);
    let desvio = 0;
    try {
      const nome = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Prague', timeZoneName: 'shortOffset' }).formatToParts(new Date(utc)).find(p => p.type === 'timeZoneName')?.value || 'GMT';
      const o = nome.match(/GMT([+-]\d{1,2})(?::(\d{2}))?/);
      if (o) desvio = (Number(o[1]) * 60 + Math.sign(Number(o[1])) * Number(o[2] || 0)) * 60000;
    } catch (e) { /* sem Intl: hora do aparelho */ }
    return utc - desvio;
  };
  const doisDigitos = n => String(n).padStart(2, '0');
  $$('[data-contagem]').forEach(el => {
    const fim = fimEmPraga(el.dataset.contagem);
    const esconder = () => { el.hidden = true; el.classList.remove('esta-ativo'); };
    if (!fim) { if (el.hasAttribute('data-esconder-no-fim')) esconder(); return; }
    const texto = $('[data-contagem-texto]', el);
    const partes = { d: $('[data-contagem-d]', el), h: $('[data-contagem-h]', el), m: $('[data-contagem-m]', el), s: $('[data-contagem-s]', el) };
    const tic = () => {
      const falta = fim - Date.now();
      if (falta <= 0) { if (el.hasAttribute('data-esconder-no-fim')) esconder(); return false; }
      const d = Math.floor(falta / 864e5), h = Math.floor(falta / 36e5) % 24, mi = Math.floor(falta / 6e4) % 60, s = Math.floor(falta / 1e3) % 60;
      if (texto) texto.textContent = d > 0 ? `${d}d ${doisDigitos(h)}:${doisDigitos(mi)}:${doisDigitos(s)}` : `${doisDigitos(h)}:${doisDigitos(mi)}:${doisDigitos(s)}`;
      if (partes.d) { partes.d.textContent = d; partes.h.textContent = doisDigitos(h); partes.m.textContent = doisDigitos(mi); partes.s.textContent = doisDigitos(s); }
      return true;
    };
    if (tic()) { const r = setInterval(() => { if (!tic()) clearInterval(r); }, 1000); }
  });
  // na barra de anúncios, a promoção que acabou sai da rotação
  $$('[data-anuncio]').forEach(a => {
    const visiveis = $$('.anuncio__item:not([hidden])', a);
    if (visiveis.length && !visiveis.some(x => x.classList.contains('esta-ativo'))) visiveis[0].classList.add('esta-ativo');
  });

  /* ---------- ofertas por quantidade (mesma coleção: 3 → 1 grátis, 6 → 2, 8 → 3) ----------
     O cesto lateral traz em JSON os códigos que o carrinho deve ter (um por coleção, o do nível atingido). O tema
     aplica-os sozinho com /cart/update.js (o cliente não escreve nada) e a Shopify calcula o grátis — só os aceita
     quando há mesmo as peças dessa coleção. Códigos que o cliente tenha posto no checkout ficam como estão. */
  const CODIGO_OFERTA = /-(2PLUS1|4PLUS2|5PLUS3)$/i;
  const lerSessao = k => { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } };
  const gravarSessao = (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) { /* sem armazenamento: só não se lembra */ } };
  const estadoOfertas = () => { try { return JSON.parse($('[data-ofertas-estado]')?.textContent || 'null'); } catch (e) { return null; } };
  const codigosDoCarrinho = c => {
    if (Array.isArray(c.discount_codes)) return c.discount_codes.map(d => d.code).filter(Boolean);
    const s = new Set();
    (c.cart_level_discount_applications || []).forEach(a => { if (a.type === 'discount_code') s.add(a.title); });
    (c.items || []).forEach(i => (i.line_level_discount_allocations || []).forEach(d => { if (d.discount_application && d.discount_application.type === 'discount_code') s.add(d.discount_application.title); }));
    return [...s];
  };
  const trocarPainel = html => {
    const novo = new DOMParser().parseFromString(html, 'text/html');
    const atual = $('[data-carrinho]');
    const vindo = $('[data-carrinho]', novo);
    if (atual && vindo) $('.gaveta__painel', atual).replaceWith($('.gaveta__painel', vindo));
  };
  // devolve true quando mudou os códigos do carrinho
  const sincronizarOfertas = async c => {
    const est = estadoOfertas();
    if (!est || !c) return false;
    const queridos = (est.codigos || []).map(x => String(x).toUpperCase()).sort();
    const atuais = codigosDoCarrinho(c);
    const nossos = atuais.filter(x => CODIGO_OFERTA.test(x)).map(x => x.toUpperCase()).sort();
    if (nossos.join(',') === queridos.join(',')) return false;
    const pedido = [...atuais.filter(x => !CODIGO_OFERTA.test(x)), ...queridos].join(',');
    // não pedir duas vezes a mesma coisa para o mesmo carrinho (se a Shopify recusou, não entra em ciclo)
    const chave = `${pedido}|${atuais.join(',')}|${(c.items || []).map(i => `${i.key}:${i.quantity}`).join(',')}`;
    if (lerSessao('musa-oferta') === chave) return false;
    gravarSessao('musa-oferta', chave);
    const r = await fetch(`${M.rotas.atualizar}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: pedido, sections: 'carrinho-gaveta' }) });
    const j = await r.json();
    if (j.sections && j.sections['carrinho-gaveta']) trocarPainel(j.sections['carrinho-gaveta']);
    return true;
  };
  // página de produto: os quadrados 3 · 6 · 8 e a frase do que falta, com o que o carrinho tem agora
  const atualizarCartaoOferta = () => {
    const cartao = $('[data-oferta-cartao]');
    if (!cartao) return;
    const h = cartao.dataset.ofertaCartao;
    const n = Number(estadoOfertas()?.colecoes?.[h] || 0);
    const nivel = n >= 8 ? 3 : n >= 6 ? 2 : n >= 3 ? 1 : 0;
    $$('[data-nivel]', cartao).forEach(li => { const m = Number(li.dataset.nivel); li.classList.toggle('esta-feito', nivel >= m); li.classList.toggle('esta-proximo', nivel === m - 1); });
    const texto = $('[data-oferta-texto]', cartao);
    const frase = $$('[data-oferta-bloco]').find(b => b.dataset.ofertaBloco === h)?.querySelector('[data-oferta-frase]');
    const comecar = $('template[data-oferta-comecar]', cartao);
    const novo = frase ? frase.innerHTML : comecar ? comecar.innerHTML : null;
    if (texto && novo !== null && texto.innerHTML.trim() !== novo.trim()) {
      texto.innerHTML = novo;
      texto.classList.remove('acabou-de-mudar'); void texto.offsetWidth; texto.classList.add('acabou-de-mudar');
    }
  };

  /* ---------- saco ---------- */
  const atualizarContadores = n => $$('[data-contador]').forEach(c => { c.textContent = n > 0 ? n : ''; c.dataset.n = n; });
  const recarregarSaco = async (abrir = false) => {
    try {
      const r = await fetch(`${M.rotas.raiz}?sections=carrinho-gaveta`);
      const j = await r.json();
      trocarPainel(j['carrinho-gaveta']);
      const c = await (await fetch(`${M.rotas.carrinho}.js`)).json();
      atualizarContadores(c.item_count);
      await sincronizarOfertas(c);
      atualizarCartaoOferta();
      if (abrir) abrirGaveta('carrinho');
    } catch (e) { console.error(e); }
  };
  // depois de pôr no saco: o quadro da coleção deste produto sobe para o topo e acende (e festeja se ganhou um grátis)
  const realcarOferta = (h, antes) => {
    if (!h) return;
    const bloco = $$('[data-oferta-bloco]').find(b => b.dataset.ofertaBloco === h);
    if (!bloco) return;
    const lista = bloco.parentElement;
    if (lista && lista.firstElementChild !== bloco) lista.prepend(bloco);
    const n = Number(bloco.dataset.ofertaN || 0);
    const nivel = x => (x >= 8 ? 3 : x >= 6 ? 2 : x >= 3 ? 1 : 0);
    bloco.classList.add('esta-novo');
    if (nivel(n) > nivel(antes)) bloco.classList.add('acabou-de-ganhar');
  };
  const adicionar = async (form, botao) => {
    if (form.reportValidity && !form.reportValidity()) return;
    botao && botao.classList.add('a-carregar');
    const h = $('[data-oferta-cartao]')?.dataset.ofertaCartao || '';
    const antes = Number(estadoOfertas()?.colecoes?.[h] || 0);
    try {
      const r = await fetch(`${M.rotas.adicionar}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || M.textos.erro);
      await recarregarSaco(true);
      realcarOferta(h, antes);
    } catch (e) {
      toast(e.message || M.textos.erro);
    } finally {
      botao && botao.classList.remove('a-carregar');
    }
  };
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-form-produto]');
    if (!f) return;
    e.preventDefault();
    adicionar(f, $('[type="submit"]', f));
  });
  const alterarLinha = async (linha, quantidade) => {
    try {
      await fetch(`${M.rotas.alterar}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(linha), quantity: Math.max(0, Number(quantidade)) }) });
      // na página do cesto: primeiro acertar as ofertas (o recarregar traz o estado novo), depois desenhar outra vez
      if (document.body.classList.contains('modelo-cart')) { await recarregarSaco(false); location.reload(); return; }
      await recarregarSaco(false);
    } catch (e) { toast(M.textos.erro); }
  };
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-linha-alterar]');
    if (!b) return;
    e.preventDefault();
    alterarLinha(b.dataset.linhaAlterar, b.dataset.qtd);
  });
  document.addEventListener('change', e => {
    const i = e.target.closest('[data-linha-input]');
    if (i) alterarLinha(i.dataset.linhaInput, i.value);
  });
  /* ---------- produto: as outras peças da mesma coleção (faixa debaixo da oferta), para juntar e chegar ao grátis ---------- */
  $$('[data-oferta-carrossel]').forEach(car => {
    const faixa = $('[data-carrossel-faixa]', car);
    const setas = $$('[data-carrossel-ir]', car);
    if (!faixa) return;
    const acertarSetas = () => {
      const fim = faixa.scrollWidth - faixa.clientWidth - 2;
      setas.forEach(b => { b.disabled = Number(b.dataset.carrosselIr) < 0 ? faixa.scrollLeft <= 2 : faixa.scrollLeft >= fim; });
    };
    setas.forEach(b => b.addEventListener('click', () => faixa.scrollBy({ left: Number(b.dataset.carrosselIr) * faixa.clientWidth, behavior: movimentoReduzido ? 'auto' : 'smooth' })));
    faixa.addEventListener('scroll', acertarSetas, { passive: true });
    window.addEventListener('resize', acertarSetas);
    acertarSetas();
  });
  document.addEventListener('change', e => { const s = e.target.closest('[data-mini-variante]'); if (s) s.classList.remove('falta-escolher'); });
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-mini-adicionar]');
    if (!b) return;
    e.preventDefault();
    const cartao = b.closest('[data-mini-cartao]');
    const car = b.closest('[data-oferta-carrossel]');
    const escolha = cartao && $('[data-mini-variante]', cartao);
    // várias cores/tamanhos: primeiro escolher (nunca vai um tamanho ao calhas)
    if (!escolha || !escolha.value) {
      if (escolha) { escolha.classList.add('falta-escolher'); escolha.focus(); }
      if (car && car.dataset.textoEscolher) toast(car.dataset.textoEscolher);
      return;
    }
    b.classList.add('a-carregar');
    try {
      const r = await fetch(`${M.rotas.adicionar}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(escolha.value), quantity: 1 }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || M.textos.erro);
      // o cesto não abre: o quadro da oferta (logo por cima) muda e o saco do cabeçalho conta mais um
      await recarregarSaco(false);
      const texto = $('span', b);
      b.classList.add('foi-adicionado');
      if (texto && car) texto.textContent = car.dataset.textoAdicionado;
      setTimeout(() => { b.classList.remove('foi-adicionado'); if (texto && car) texto.textContent = car.dataset.textoBotao; }, 2200);
    } catch (err) {
      toast(err.message || M.textos.erro);
    } finally {
      b.classList.remove('a-carregar');
    }
  });
  // ao abrir qualquer página: os códigos das ofertas de acordo com o carrinho (pode ter mudado noutro separador)
  if (estadoOfertas()) {
    fetch(`${M.rotas.carrinho}.js`).then(r => r.json()).then(async c => {
      const mudou = await sincronizarOfertas(c);
      if (mudou && document.body.classList.contains('modelo-cart')) location.reload();
      else if (mudou) atualizarCartaoOferta();
    }).catch(() => {});
  }

  /* ---------- pesquisa ---------- */
  const pesquisa = $('[data-pesquisa]');
  const campo = $('[data-pesquisa-campo]');
  const resultados = $('[data-pesquisa-resultados]');
  const inicioPesquisa = resultados ? resultados.innerHTML : '';
  function fecharPesquisa() {
    if (!pesquisa || !pesquisa.classList.contains('esta-aberta')) return;
    pesquisa.classList.remove('esta-aberta');
    pesquisa.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', e => {
    if (e.target.closest('[data-abrir-pesquisa]') && pesquisa) {
      e.preventDefault();
      fecharGaveta(false);
      pesquisa.classList.add('esta-aberta');
      pesquisa.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(() => campo && campo.focus(), 60);
    }
    if (e.target.closest('[data-fechar-pesquisa]')) fecharPesquisa();
  });
  let pesquisaTempo;
  campo && campo.addEventListener('input', () => {
    clearTimeout(pesquisaTempo);
    const q = campo.value.trim();
    if (q.length < 2) { resultados.innerHTML = inicioPesquisa; return; }
    pesquisaTempo = setTimeout(async () => {
      try {
        const r = await fetch(`${M.rotas.sugestoes}?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][fields]=title,product_type,variants.title&section_id=pesquisa-sugestoes`);
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const conteudo = $('[data-sugestoes]', doc);
        resultados.innerHTML = conteudo && conteudo.innerHTML.trim() ? conteudo.innerHTML : `<p class="texto-suave">${M.textos.semResultados}</p>`;
      } catch (e) { resultados.innerHTML = inicioPesquisa; }
    }, 220);
  });

  /* ---------- coleção: ordem e "ver mais" ---------- */
  const ordem = $('[data-ordem]');
  ordem && ordem.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', ordem.value); u.searchParams.delete('page'); location.href = u.toString(); });
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-ver-mais]');
    if (!b) return;
    e.preventDefault();
    const grelha = $('[data-grelha-colecao]');
    if (!grelha) { location.href = b.href; return; }
    b.classList.add('a-carregar');
    const carregada = b.href;
    try {
      const doc = new DOMParser().parseFromString(await (await fetch(carregada)).text(), 'text/html');
      $$('[data-grelha-colecao] > *', doc).forEach(c => grelha.appendChild(c));
      const prox = $('[data-ver-mais]', doc);
      const progresso = $('[data-progresso]');
      const progressoNovo = $('[data-progresso]', doc);
      if (progresso && progressoNovo) progresso.textContent = progressoNovo.textContent;
      if (prox) { b.href = prox.href; } else { $('[data-ver-mais-zona]').remove(); }
      history.replaceState({}, '', carregada);
    } catch (err) { location.href = b.href; }
    finally { b.classList.remove('a-carregar'); }
  });

  /* ---------- rodapé: no telemóvel, os menus começam fechados ---------- */
  if (!window.matchMedia('(min-width: 750px)').matches) $$('[data-rodape-menu]').forEach(d => d.removeAttribute('open'));
  $$('[data-rodape-menu] summary').forEach(s => s.addEventListener('click', e => { if (window.matchMedia('(min-width: 750px)').matches) e.preventDefault(); }));

  /* ---------- página de produto ---------- */
  const prod = $('[data-produto]');
  if (prod) {
    const dados = JSON.parse($('[data-produto-json]')?.textContent || '{}');
    const variantes = dados.variantes || [];
    const form = $('[data-form-produto]', prod);
    const idInput = form && $('input[name="id"]', form);
    const botao = form && $('[data-botao-comprar]', form);
    const precoEl = $('[data-produto-preco]', prod);
    const faixa = $('[data-galeria-faixa]', prod);
    const atualEl = $('[data-galeria-atual]', prod);
    const pontos = $$('.galeria__pontos i', prod);

    // galeria do telemóvel: contador e pontos
    const indiceVisivel = () => faixa ? Math.round(faixa.scrollLeft / Math.max(1, faixa.clientWidth)) : 0;
    faixa && faixa.addEventListener('scroll', () => {
      const i = indiceVisivel();
      if (atualEl) atualEl.textContent = i + 1;
      pontos.forEach((p, k) => p.classList.toggle('esta-ativo', k === i));
    }, { passive: true });
    const irParaMedia = id => {
      const s = faixa && $(`[data-media-id="${id}"]`, faixa);
      if (!s) return;
      // telemóvel: a galeria desliza até à fotografia da cor
      if (faixa.scrollWidth > faixa.clientWidth + 4) { faixa.scrollTo({ left: s.offsetLeft - faixa.offsetLeft, behavior: 'smooth' }); return; }
      // computador: a fotografia da cor escolhida passa a ser a grande, a primeira da grelha
      if (faixa.firstElementChild !== s) faixa.prepend(s);
      const topo = faixa.getBoundingClientRect().top + window.scrollY - (cab ? cab.offsetHeight : 0) - 16;
      if (window.scrollY > topo + 40) window.scrollTo({ top: topo, behavior: 'smooth' });
    };

    // medidas do tamanho escolhido, tiradas da tabela do guia (1.ª coluna = tamanho)
    const medidasEl = $('[data-medidas]', prod);
    const tabelaGuia = $('#guia-tamanhos table');
    const idxTamanho = Number(prod.dataset.idxTamanho);
    const esc = t => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    const linhasGuia = tabelaGuia ? [...tabelaGuia.rows].map(r => [...r.cells].map(c => c.textContent.trim())) : [];
    const normTamanho = t => String(t || '').toLowerCase().replace(/\s+/g, '').replace(/^(eu|velikost|tamanho)/, '').replace(',', '.');
    const comUnidade = (cabecalho, valor) => (/^(eu|velikost|tamanho)/i.test(cabecalho) || /[a-z]/i.test(valor) || !/\d/.test(valor)) ? valor : `${valor} cm`;
    const mostrarMedidas = tamanho => {
      if (!medidasEl || linhasGuia.length < 2) return;
      const [cabecalho, ...corpo] = linhasGuia;
      const linha = corpo.find(l => normTamanho(l[0]) === normTamanho(tamanho));
      if (!linha) { medidasEl.hidden = true; return; }
      const itens = cabecalho.slice(1).map((h, k) => [h, linha[k + 1]]).filter(([h, v]) => h && v);
      medidasEl.innerHTML = `<p class="medidas__titulo">${esc((M.textos.medidas || '').replace('__T__', tamanho))}</p><dl class="medidas__lista">${itens.map(([h, v]) => `<div><dt>${esc(h)}</dt><dd>${esc(comUnidade(h, v))}</dd></div>`).join('')}</dl>`;
      medidasEl.hidden = false;
    };

    // ampliar as fotografias
    const amp = $('[data-ampliacao]');
    $$('[data-ampliar]', prod).forEach(b => b.addEventListener('click', () => {
      if (!amp || !amp.showModal) return;
      $$('img[data-src]', amp).forEach(img => { img.src = img.dataset.src; img.removeAttribute('data-src'); });
      amp.showModal();
      document.documentElement.style.overflow = 'hidden';
      const alvo = $$('img', amp)[Number(b.dataset.ampliar)];
      alvo && setTimeout(() => alvo.scrollIntoView({ block: 'start' }), 30);
    }));
    amp && amp.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    amp && $('[data-fechar-ampliacao]', amp)?.addEventListener('click', () => amp.close());

    // preço com o riscado limitado a −50% (igual ao snippet preco.liquid)
    const desenharPreco = (v, comSelo = true) => {
      const teto = v.preco * 2;
      const riscado = Math.min(v.riscado || 0, teto);
      const desconto = riscado > v.preco ? Math.floor((riscado - v.preco) * 100 / riscado) : 0;
      return `<span class="preco${desconto > 0 ? ' preco--promo' : ''}"><span class="preco__atual">${dinheiro(v.preco)}</span>${desconto > 0 ? `<s class="preco__riscado">${dinheiro(riscado)}</s>${comSelo ? `<span class="preco__desconto">−${desconto}%</span>` : ''}` : ''}</span>`;
    };
    const escolhidas = () => $$('[data-opcao]', prod).map(g => ($('input:checked', g) || {}).value);
    const atualizarVariante = () => {
      if (variantes.length < 2) return;
      const ops = escolhidas();
      if (idxTamanho >= 0) mostrarMedidas(ops[idxTamanho]);
      $$('[data-opcao]', prod).forEach((g, i) => { const leg = $('[data-opcao-valor]', g); if (leg) leg.textContent = ops[i] || ''; });
      // marcar as combinações que não existem ou estão esgotadas com a escolha atual das outras opções
      $$('[data-opcao]', prod).forEach((g, i) => {
        $$('input', g).forEach(inp => {
          const teste = ops.slice(); teste[i] = inp.value;
          const ok = variantes.some(v => v.opcoes.every((o, k) => o === teste[k]) && v.disponivel);
          inp.closest('label').classList.toggle('esta-esgotada', !ok);
        });
      });
      const v = variantes.find(x => x.opcoes.every((o, i) => o === ops[i]));
      const texto = botao && $('[data-botao-texto]', botao);
      if (!v) { if (botao) { botao.disabled = true; texto.textContent = M.textos.indisponivel; } return; }
      idInput.value = v.id;
      if (botao) { botao.disabled = !v.disponivel; texto.textContent = v.disponivel ? M.textos.adicionar : M.textos.esgotado; }
      if (precoEl) precoEl.innerHTML = desenharPreco(v);
      const barraPreco = $('[data-barra-preco]');
      if (barraPreco) barraPreco.innerHTML = desenharPreco(v, false);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      if (v.media) irParaMedia(v.media);
    };
    $$('[data-opcao] input', prod).forEach(i => i.addEventListener('change', atualizarVariante));
    if (variantes.length > 1) {
      // estado inicial das combinações (sem mexer na galeria)
      const ops = escolhidas();
      if (idxTamanho >= 0) mostrarMedidas(ops[idxTamanho]);
      $$('[data-opcao]', prod).forEach((g, i) => $$('input', g).forEach(inp => {
        const teste = ops.slice(); teste[i] = inp.value;
        const ok = variantes.some(v => v.opcoes.every((o, k) => o === teste[k]) && v.disponivel);
        inp.closest('label').classList.toggle('esta-esgotada', !ok);
      }));
    }

    // entrega estimada em três passos (dias úteis das definições do tema), com as datas à checa (21. 10., 23.–27. 10.)
    const entrega = $('[data-entrega]', prod);
    if (entrega && M.entrega) {
      const somarUteis = n => { const d = new Date(); let f = 0; while (f < n) { d.setDate(d.getDate() + 1); const s = d.getDay(); if (s !== 0 && s !== 6) f++; } return d; };
      const dia = d => `${d.getDate()}.\u00a0${d.getMonth() + 1}.`;
      const intervalo = (a, b) => a.toDateString() === b.toDateString() ? dia(a)
        : a.getMonth() === b.getMonth() ? `${a.getDate()}.–${b.getDate()}.\u00a0${b.getMonth() + 1}.` : `${dia(a)} – ${dia(b)}`;
      const por = (sel, texto) => { const el = $(sel, entrega); if (el) el.textContent = texto; };
      const n = (v, d) => Number(v) || d;
      por('[data-entrega-hoje]', `${M.textos.hoje || 'Dnes'}, ${dia(new Date())}`);
      por('[data-entrega-envio]', intervalo(somarUteis(n(M.entrega.prepMin, 1)), somarUteis(n(M.entrega.prepMax, 3))));
      por('[data-entrega-chegada]', intervalo(somarUteis(n(M.entrega.min, 6)), somarUteis(n(M.entrega.max, 13))));
    }

    // barra de compra no telemóvel, quando o botão sai do ecrã
    const barra = $('[data-barra-compra]');
    if (barra && botao && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const ver = !en.isIntersecting && en.boundingClientRect.top < 0;
        barra.classList.toggle('esta-visivel', ver);
        barra.setAttribute('aria-hidden', String(!ver));
        const b = $('[data-barra-botao]', barra); if (b) b.tabIndex = ver ? 0 : -1;
      }).observe(botao);
      $('[data-barra-botao]', barra)?.addEventListener('click', () => {
        if (botao.disabled) { botao.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }
})();
